import React from "react";

function Div2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="317"
      height="195"
      fill="none"
      viewBox="0 0 317 195"
    >
      <g filter="url(#filter0_d_255_1023)">
        <path
          stroke="#61FF00"
          strokeWidth="0.802"
          d="M14 155.77l37.631 25.147h125.856M303.343 45.098l-30.942-30.894h-129.2"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_d_255_1023"
          width="315.496"
          height="193.162"
          x="0.953"
          y="0.979"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="6.412"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.38 0 0 0 0 1 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_255_1023"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_255_1023"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default Div2;